document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('new-product-form')) {
    customElements.define(
      'new-product-form',
      class NewProductForm extends HTMLElement {
        constructor() {
          super()
        }

        connectedCallback() {
          this.querySelector('button').addEventListener('click', e => {
            const variantId = parseFloat(this.querySelector('input[name="id"]').value)
            let items = [{
              'id': variantId,
              'quantity': 1,
            }];

            // Check if package3 is active and add metafield product
            const package3Container = document.querySelector('.package-package3');
            const wasPackageActive = package3Container && package3Container.dataset.packageActive === 'true';
            
            if (wasPackageActive) {
              const packageButton = package3Container.querySelector('.package-add-btn');
              if (packageButton) {
                const variantIdAttr = packageButton.dataset.variantId;
                if (variantIdAttr && variantIdAttr !== '') {
                  const metafieldVariantId = parseFloat(variantIdAttr);
                  console.log('Package active, metafield variant ID:', metafieldVariantId);
                  if (metafieldVariantId && !isNaN(metafieldVariantId)) {
                    items.push({
                      'id': metafieldVariantId,
                      'quantity': 1,
                    });
                    console.log('Added metafield product to cart items:', items);
                  } else {
                    console.warn('Invalid metafield variant ID:', variantIdAttr);
                    alert('Error: Metafield product variant ID is invalid. Please check the product metafield configuration.');
                  }
                } else {
                  console.warn('Metafield product variant ID is missing. Please ensure the custom.product metafield is set correctly.');
                  alert('Error: Metafield product not found. Please check the product metafield configuration.');
                }
              } else {
                console.warn('Package button not found');
              }
            }
            
            console.log('Cart items to add:', items);

            let formData = {
              'items': items
            };

            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            })
            .then(response => response.json())
            .then(data => {
              // Check if there was an error
              if (data.status) {
                console.error('Cart add error:', data.description);
                alert('Error adding to cart: ' + (data.description || 'Unknown error'));
                return;
              }

              // Reset package button state after successful add
              if (wasPackageActive && package3Container) {
                const packageButton = package3Container.querySelector('.package-add-btn');
                if (packageButton) {
                  package3Container.dataset.packageActive = 'false';
                  package3Container.classList.remove('active');
                  packageButton.textContent = '+ Add';
                  packageButton.classList.remove('bg-[#00BB7B]');
                  packageButton.classList.add('bg-[#A9A494]');
                }
              }

              // Update cart drawer
              fetch('/?sections=header')
              .then((res) => res.json())
              .then((res) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(res['header'], 'text/html');
                document.querySelector('.shopping_cart .product_actions').innerHTML = doc.querySelector('.shopping_cart .product_actions').innerHTML
                document.querySelector('.shopping_cart .cart__drawer__items').innerHTML = doc.querySelector('.shopping_cart .cart__drawer__items').innerHTML
                document.querySelector('.shopping_cart').classList.toggle('modal_show');
              });

              fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                const totalPrice = cart.total_price;
                updateInstallmentPrice(totalPrice);
              });
            })
            .catch((error) => {
              console.error('Error:', error);
              alert('Error adding to cart. Please try again.');
            });
          })
        }
      }
    )
  }
  FoxTheme.Currency = (function () {
    const moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

    function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0, '.');
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }

      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }

      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;
    }

    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit,
    };
  })();
  if (!customElements.get('option-selects-pdp')) {
    customElements.define(
      'option-selects-pdp',
      class OptionSelectsPdp extends HTMLElement {
        constructor() {
          super()
        }

        get selectedOptionValues() {
          const options = {}
          this.querySelectorAll('input:checked').forEach((node, index) => {
            const newIndex = index + 1
            const optionName = 'option' + newIndex
            options[optionName] = node.value
          })
          return options
        }

        getSelectedVariant() {
          const options = this.selectedOptionValues
          const activeVariants = mainProductVariant['variants']
          let selectedVariant = mainProductVariant['activeVariant']

          activeVariants.forEach(variant => {
            let correctVariant = true
            for (const key in options) {
              if (variant[key] !== options[key]) {
                correctVariant = false
                continue
              }
            }
            if (correctVariant) {
              selectedVariant = variant
            }
          })

          if (selectedVariant) {
            document.querySelector('.product-regular-price').textContent = FoxTheme.Currency.formatMoney(selectedVariant.compare_at_price, FoxTheme.settings.moneyFormat);
            document.querySelector('.product-sale-price').textContent = FoxTheme.Currency.formatMoney(selectedVariant.price, FoxTheme.settings.moneyFormat);

            document.querySelector('.installment-price3').textContent = 'of 3 x ' + FoxTheme.Currency.formatMoney(Math.trunc(selectedVariant.price * 100) / 300, FoxTheme.settings.moneyFormat);
            document.querySelector('.installment-price60').textContent = 'Vanaf ' + FoxTheme.Currency.formatMoney((selectedVariant.price / 60).toFixed(0), FoxTheme.settings.moneyFormat) + ' p/m';

            document.querySelector('.product-installment3').textContent = FoxTheme.Currency.formatMoney(Math.trunc(selectedVariant.price * 100) / 300, FoxTheme.settings.moneyFormat);
            document.querySelector('.product-installment60').textContent = FoxTheme.Currency.formatMoney((selectedVariant.price / 60).toFixed(0), FoxTheme.settings.moneyFormat);
            document.querySelector('.product-installment60-table').innerHTML = `
                <table cellpadding="0" cellspacing="0" style="width: 100%; text-align: center; background: #EAF7F3; border-radius: 0.6rem; border-spacing: 0.5rem; overflow: hidden;">
                  <tr>
                      <td style="border: 1px solid #E5E7Eb; padding: 10px 0;"><strong>12 keer</strong><br><span class="product-table-installment-12">${FoxTheme.Currency.formatMoney((selectedVariant.price / 12).toFixed(0), FoxTheme.settings.moneyFormat)}</span></td>
                      <td style="border: 1px solid #E5E7Eb; padding: 10px 0;"><strong>18 keer</strong><br><span class="product-table-installment-18">${FoxTheme.Currency.formatMoney((selectedVariant.price / 18).toFixed(0), FoxTheme.settings.moneyFormat)}</span></td>
                      <td style="border: 1px solid #E5E7Eb; padding: 10px 0;"><strong>24 keer</strong><br><span class="product-table-installment-24">${FoxTheme.Currency.formatMoney((selectedVariant.price / 24).toFixed(0), FoxTheme.settings.moneyFormat)}</span></td>
                      <td style="border: 1px solid #E5E7Eb; padding: 10px 0;"><strong>36 keer</strong><br><span class="product-table-installment-36">${FoxTheme.Currency.formatMoney((selectedVariant.price / 36).toFixed(0), FoxTheme.settings.moneyFormat)}</span></td>
                      <td style="border: 1px solid #E5E7Eb; padding: 10px 0;"><strong>60 keer</strong><br><span class="product-table-installment-60">${FoxTheme.Currency.formatMoney((selectedVariant.price / 60).toFixed(0), FoxTheme.settings.moneyFormat)}</span></td>
                  </tr>
                </table>
              `;
            
            if (selectedVariant.available) {
              document.querySelector('new-product-form button').disabled = false
              document.querySelector('new-product-form button').innerHTML = `
                <img src="//www.mijnboxspring.nl/cdn/shop/t/33/assets/shopping-cart.svg?v=44493134012605397321763139431" class="w-[15px]" width="auto" height="auto" alt="shopping">
                <span>In winkelwagen - ${FoxTheme.Currency.formatMoney(selectedVariant.price, FoxTheme.settings.moneyFormat)}</span>
              `
              document.querySelector('new-product-form button').classList.remove('bg-[#A9A493]')
              document.querySelector('new-product-form button').classList.add('bg-[#F86F60]')
            } else {
              document.querySelector('new-product-form button').disabled = true
              document.querySelector('new-product-form button').innerHTML = `
                <span>Out of Stock</span>
              `
              document.querySelector('new-product-form button').classList.add('bg-[#A9A494]')
              document.querySelector('new-product-form button').classList.remove('bg-[#F86F60]')
            }
          }

          return selectedVariant
        }

        connectedCallback() {
          this.productId = this.dataset.productId
          this.addEventListener('change', (event) => {
            const options = this.selectedOptionValues
            const activeVariant = this.getSelectedVariant()
            this.parentElement.querySelector('new-product-form input[name="id"]').value = activeVariant.id
          })
        }
      }
    )
  }
})
        
// thumbSlider
const thumbSlider = new Swiper('.product_slider_thumb', {
  spaceBetween: 6,
  slidesPerView: 'auto',
  freeMode: true,
  watchSlidesProgress: true,
})

// mainSlider
const mainSlider = new Swiper('.product_slider_main', {
  spaceBetween: 16,
  loop: true,
  pagination: {
    el: '.product_slider_main .swiper-pagination',
    clickable: true,
  },
  thumbs: {
    swiper: thumbSlider,
  },
})

// Custom Zoom Functionality
document.addEventListener('DOMContentLoaded', () => {
  const zoomOverlay = document.getElementById('customZoomOverlay');
  const zoomImage = document.getElementById('customZoomImage');
  const zoomClose = document.getElementById('customZoomClose');
  let isZoomed = false;

  // Function to open zoom
  function openZoom(imageSrc) {
    if (!zoomOverlay || !zoomImage) return;
    
    zoomImage.src = imageSrc;
    zoomImage.classList.remove('zoomed');
    isZoomed = false;
    zoomOverlay.classList.add('active');
    document.body.classList.add('custom-zoom-overlay-body-lock');
    document.documentElement.classList.add('custom-zoom-overlay-body-lock');
  }

  // Function to close zoom
  function closeZoom() {
    if (!zoomOverlay) return;
    
    zoomOverlay.classList.remove('active');
    zoomImage.classList.remove('zoomed');
    isZoomed = false;
    document.body.classList.remove('custom-zoom-overlay-body-lock');
    document.documentElement.classList.remove('custom-zoom-overlay-body-lock');
  }

  // Function to toggle zoom level
  function toggleZoom() {
    if (!zoomImage) return;
    
    isZoomed = !isZoomed;
    if (isZoomed) {
      zoomImage.classList.add('zoomed');
    } else {
      zoomImage.classList.remove('zoomed');
    }
  }

  // Add click event to all zoom images
  const zoomImages = document.querySelectorAll('.product-zoom-image');
  zoomImages.forEach(img => {
    img.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const zoomSrc = img.getAttribute('data-zoom-src') || img.src;
      openZoom(zoomSrc);
    });
  });

  // Click on zoom image to toggle zoom level
  if (zoomImage) {
    zoomImage.addEventListener('click', (e) => {
      e.stopPropagation();
      toggleZoom();
    });
  }

  // Click on overlay to close
  if (zoomOverlay) {
    zoomOverlay.addEventListener('click', (e) => {
      // Get the clicked element
      const clickedElement = e.target;
      
      // Don't close if clicking on the image or close button
      if (clickedElement === zoomImage || 
          clickedElement.id === 'customZoomImage' ||
          clickedElement === zoomClose || 
          clickedElement.id === 'customZoomClose' ||
          clickedElement.closest('#customZoomClose')) {
        return;
      }
      
      // Close if clicking anywhere else (overlay background or container)
      closeZoom();
    });
  }

  // Close button
  if (zoomClose) {
    zoomClose.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeZoom();
    });
  }

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && zoomOverlay && zoomOverlay.classList.contains('active')) {
      closeZoom();
    }
  });

  // Handle package3 add button click
  const packageAddBtn = document.querySelector('.package-package3 .package-add-btn');
  if (packageAddBtn) {
    packageAddBtn.addEventListener('click', function(e) {
      e.preventDefault();
      const packageContainer = this.closest('.package-package3');
      const isActive = packageContainer.dataset.packageActive === 'true';
      
      if (isActive) {
        // Remove active state
        packageContainer.dataset.packageActive = 'false';
        packageContainer.classList.remove('active');
        this.textContent = '+ Voeg toe';
        this.classList.remove('bg-[#00BB7B]');
        this.classList.add('bg-[#A9A494]');
      } else {
        // Add active state
        packageContainer.dataset.packageActive = 'true';
        packageContainer.classList.add('active');
        this.textContent = '✓ Toegevoegd';
        this.classList.remove('bg-[#A9A494]');
        this.classList.add('bg-[#00BB7B]');
      }
    });
  }

  function updateInstallmentPrice(totalPrice) {
    document.querySelector('.cart-installment3-price').textContent = 'of 3 x ' + FoxTheme.Currency.formatMoney(Math.trunc(totalPrice * 100) / 300, FoxTheme.settings.moneyFormat);
    document.querySelector('.cart-installment60-price').textContent = 'Vanaf ' + FoxTheme.Currency.formatMoney((totalPrice / 60).toFixed(0), FoxTheme.settings.moneyFormat) + ' p/m';

    document.querySelector('.cart-installment3').textContent = FoxTheme.Currency.formatMoney(Math.trunc(totalPrice * 100) / 300, FoxTheme.settings.moneyFormat);
    document.querySelector('.cart-installment60').textContent = FoxTheme.Currency.formatMoney((totalPrice / 60).toFixed(0), FoxTheme.settings.moneyFormat);
    document.querySelector('.cart-installment60-table').innerHTML = `
      <table cellpadding="0" cellspacing="0" style="width: 100%; text-align: center; background: #EAF7F3; border-radius: 0.6rem; border-spacing: 0.5rem; overflow: hidden;">
        <tr>
            <td style="border: 1px solid #E5E7Eb; padding: 10px 0;"><strong>12 keer</strong><br><span class="product-table-installment-12">${FoxTheme.Currency.formatMoney((totalPrice / 12).toFixed(0), FoxTheme.settings.moneyFormat)}</span></td>
            <td style="border: 1px solid #E5E7Eb; padding: 10px 0;"><strong>18 keer</strong><br><span class="product-table-installment-18">${FoxTheme.Currency.formatMoney((totalPrice / 18).toFixed(0), FoxTheme.settings.moneyFormat)}</span></td>
            <td style="border: 1px solid #E5E7Eb; padding: 10px 0;"><strong>24 keer</strong><br><span class="product-table-installment-24">${FoxTheme.Currency.formatMoney((totalPrice / 24).toFixed(0), FoxTheme.settings.moneyFormat)}</span></td>
            <td style="border: 1px solid #E5E7Eb; padding: 10px 0;"><strong>36 keer</strong><br><span class="product-table-installment-36">${FoxTheme.Currency.formatMoney((totalPrice / 36).toFixed(0), FoxTheme.settings.moneyFormat)}</span></td>
            <td style="border: 1px solid #E5E7Eb; padding: 10px 0;"><strong>60 keer</strong><br><span class="product-table-installment-60">${FoxTheme.Currency.formatMoney((totalPrice / 60).toFixed(0), FoxTheme.settings.moneyFormat)}</span></td>
        </tr>
      </table>
    `;
  }

  const OptionSelectSwatch = document.querySelectorAll('option-selects-pdp .swatch-input__input');

  OptionSelectSwatch.forEach((el) => {
    if (el.hasAttribute('checked')) {
        el.checked = true;
    }
  })
});
